import { brl } from "@/lib/format";

const esc = (s) => String(s ?? "").replace(/[&<>]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;" }[c]));

export const receiptHtml = (o, r) => `<!doctype html><html><head><meta charset="utf-8"><title>Pedido #${o.number}</title>
<style>@page{margin:4mm;size:80mm auto}body{font-family:'Courier New',monospace;font-size:12px;width:72mm;margin:0;color:#000}
h1{font-size:16px;margin:0;text-align:center}.c{text-align:center}.l{border-top:1px dashed #000;margin:6px 0}
table{width:100%;border-collapse:collapse}td{padding:2px 0;vertical-align:top}.r{text-align:right}.b{font-weight:bold}.big{font-size:20px}</style></head><body>
<h1>${esc(r?.name || "Pedido")}</h1>${r?.phone ? `<div class="c">${esc(r.phone)}</div>` : ""}
<div class="l"></div><div class="big b c">PEDIDO #${o.number}</div>
<div class="c">${new Date(o.created_at).toLocaleString("pt-BR")}</div>
<div class="c b">${esc((o.channel || "").toUpperCase())}${o.customer_name ? " · " + esc(o.customer_name) : ""}</div>
${o.customer_phone ? `<div class="c">${esc(o.customer_phone)}</div>` : ""}${o.address ? `<div>${esc(o.address)}</div>` : ""}
<div class="l"></div><table>${(o.items || []).map((i) => `<tr><td class="b">${i.quantity}x</td><td>${esc(i.name)}${i.notes ? `<br><small>obs: ${esc(i.notes)}</small>` : ""}</td><td class="r">${brl(i.price * i.quantity)}</td></tr>`).join("")}</table>
<div class="l"></div>${o.delivery_fee ? `<div>Entrega: <span class="r">${brl(o.delivery_fee)}</span></div>` : ""}${o.discount ? `<div>Desconto: -${brl(o.discount)}</div>` : ""}
<div class="big b">TOTAL: ${brl(o.total)}</div><div>Pagamento: ${esc(o.payment_method || "-")}</div>
${o.notes ? `<div class="l"></div><div><b>Obs:</b> ${esc(o.notes)}</div>` : ""}<div class="l"></div><div class="c">Obrigado pela preferência!</div>
</body></html>`;

let frame = null;
export const printOrder = (order, restaurant) => {
  if (frame) frame.remove();
  frame = document.createElement("iframe");
  frame.setAttribute("aria-hidden", "true");
  frame.style.cssText = "position:fixed;right:0;bottom:0;width:0;height:0;border:0;";
  document.body.appendChild(frame);
  const doc = frame.contentWindow.document;
  doc.open(); doc.write(receiptHtml(order, restaurant)); doc.close();
  frame.contentWindow.focus();
  setTimeout(() => { try { frame.contentWindow.print(); } catch { /* blocked */ } }, 150);
};
